import * as React from 'react';
import { styled } from '@mui/material/styles';
import './OtsMoreButtons.scss';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import FlightPathModal from '../Modal/FlightPathModal';
import { useDispatch } from "react-redux";
import { showFlightSchedule } from "../../store/feature/OpenEventsListSlice";
import { viewflightSchedule } from "../../store/feature/FlightScheduleSlice";
import appSettings from "../../appSettings.js";
import { OtsAircraft } from '../../Models/OtsAircraft';
import { IsAuthorized, useAuthorization } from "meportal/AuthorizationProvider";
import { AccessTimeline, FlightScheduleButton } from '../../constants/PermissionSet';
import * as DropdownConstant from "../../constants/DropdownConstants"

const MoreButtons = styled((props: MenuProps & {PopperProps?: any}) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    height: 'auto',
    width: 170,
    color: '#0074C8',
    border: '1px solid #D9DFE4',
    boxShadow: '0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1)',
    position: 'absolute',
    right: 0,    
    '& .MuiMenu-list': {
      padding: '1px 0',
      '& .MuiDivider-root': {
        margin: '0',
      },
      '& .MuiMenuItem-root': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
      '& .MuiMenuItem-root:hover': {
        backgroundColor: 'var(--light-background-gray-color)', 
      },
      '& .MuiMenuItem-root:active': {
        backgroundColor: 'var(--light-background-gray-color)', 
      },
    },
    '& .MuiMenuItem-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontFamily: 'var(--auro-font-family-default)',
      fontWeight: 450,
      lineHeight: '100%',
      letterSpacing: '-0.32px',
    },
  },
}));


interface OtsMoreButtonsProps {
    otsEvent: OtsAircraft; 
    handleOtsEventClick?: (otsEvent: OtsAircraft) => void;
    handleOtsFilterClick?: any;
}

const OtsMoreButtons: React.FC<OtsMoreButtonsProps> = ({
  otsEvent,
  handleOtsEventClick,
  handleOtsFilterClick
}) => {
  const { eventPermissions, userClaims } = useAuthorization();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open: boolean = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): void => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    const handleScroll = () => {
      if (open) {
        handleClose();
      }
    };

    if (open) {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [open]);

  const handleFlightPathClick = (event: React.MouseEvent<HTMLElement>): void => {    
    event.stopPropagation();
    dispatch(viewflightSchedule([]));
    dispatch(showFlightSchedule(otsEvent.AircraftRegistration));
    handleClose();
  };

  const handleFlightPathCloseModalClick = (event: React.MouseEvent<HTMLElement>): void => {

    event.stopPropagation();
    dispatch(showFlightSchedule(otsEvent.AircraftRegistration));
    dispatch(viewflightSchedule([]));
    handleClose();
  };

   const handleACHistoryClick = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      console.log("ac History URL", appSettings.AIRCRAFT_MTX_HISTORY_BASE_URL);
      const aircraftMtxHistoryUrl = `${appSettings.AIRCRAFT_MTX_HISTORY_BASE_URL}?airlines=${otsEvent.Airline}&aircraft=N${otsEvent.AircraftRegistration}`;
      window.open(aircraftMtxHistoryUrl, "_blank");
      handleClose();
    }; 
     const attachmentHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        if (handleOtsEventClick && otsEvent.id) {
          handleOtsFilterClick("attachment");
          handleOtsEventClick(otsEvent);
        }
      };

      const handleFieldTrip = (event: React.MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
          if (handleOtsEventClick) {
            handleOtsFilterClick("fieldTrip");
            handleOtsEventClick(otsEvent);
          }
          handleClose();
        };

        const handleSPF = (event: React.MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
          if (handleOtsEventClick) {
            handleOtsFilterClick("ferryFlight");
            handleOtsEventClick(otsEvent);
          }
          handleClose();
        };

        const enableAttachmentButton = () => {
            if (
              IsAuthorized(
                otsEvent.Airline + ":" + otsEvent.EventType,
                AccessTimeline,
                eventPermissions,
                userClaims
              ) === false
            ) {
              return true;
            }
            return !otsEvent?.HasPublicAttachment;
          };

          const specialEventChecker = (info: string) => {
              if (
                IsAuthorized(
                  otsEvent.Airline + ":" + otsEvent.EventType,
                  AccessTimeline,
                  eventPermissions,
                  userClaims
                ) === false
              ) {
                return true;
              }
          
              let data = otsEvent?.SpecialEventHistory;
              if (data != null) {
                for (let i = 0; i < data.length; i++) {
                  if (data[i].SpecialEventType === info) {
                    return false;
                  }
                }
              }
              return true;
            };

      const permissionCheck = () => {
        return !IsAuthorized(
          otsEvent.Airline + ":" + otsEvent.EventType,
          FlightScheduleButton,
          eventPermissions,
          userClaims
        );
      }
              
  return (
    <div onClick={(event) => {
      event.stopPropagation(); // Stop propagation at the root level
    }}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        e.stopPropagation();
      }
    }}
    >
      <div className="more-list-icon" onClick={handleClick} role="button" tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleClick(e);
        }
      }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={open ? "icon-path-open" : "icon-path"} xmlns="http://www.w3.org/2000/svg">
          <g id="interface/more-stroke">
            <g id="Icon">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.99968 13.7777C11.1907 13.7777 13.7775 11.1909 13.7775 7.99987C13.7775 4.80889 11.1907 2.2221 7.99968 2.2221C4.8087 2.2221 2.2219 4.80889 2.2219 7.99987C2.2219 11.1909 4.8087 13.7777 7.99968 13.7777ZM7.99968 14.6665C11.6816 14.6665 14.6663 11.6818 14.6663 7.99987C14.6663 4.31797 11.6816 1.33321 7.99968 1.33321C4.31778 1.33321 1.33301 4.31797 1.33301 7.99987C1.33301 11.6818 4.31778 14.6665 7.99968 14.6665Z"
                className={open ? "icon-path-open" : "icon-path"}
              />
              <path
                d="M5.99967 8.19987C5.99967 8.75216 5.55196 9.19987 4.99967 9.19987C4.44739 9.19987 3.99967 8.75216 3.99967 8.19987C3.99967 7.64759 4.44739 7.19987 4.99967 7.19987C5.55196 7.19987 5.99967 7.64759 5.99967 8.19987Z"
                className={open ? "icon-path-open" : "icon-path"}
              />
              <path
                d="M8.99968 8.19987C8.99968 8.75216 8.55196 9.19987 7.99968 9.19987C7.44739 9.19987 6.99968 8.75216 6.99968 8.19987C6.99968 7.64759 7.44739 7.19987 7.99968 7.19987C8.55196 7.19987 8.99968 7.64759 8.99968 8.19987Z"
                className={open ? "icon-path-open" : "icon-path"}
              />
              <path
                d="M11.9997 8.19987C11.9997 8.75216 11.552 9.19987 10.9997 9.19987C10.4474 9.19987 9.99968 8.75216 9.99968 8.19987C9.99968 7.64759 10.4474 7.19987 10.9997 7.19987C11.552 7.19987 11.9997 7.64759 11.9997 8.19987Z"
                className={open ? "icon-path-open" : "icon-path"}
              />
            </g>
          </g>
        </svg>
      </div>

      <MoreButtons
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        sx={{
          '& .MuiPaper-root': {
            left: 'unset !important',
            maxHeight: '250px',
            overflow : 'auto'
          },
        }}
      >
        <MenuItem sx={{
    "&:hover": {
      backgroundColor: "transparent", 
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
  }} onClick={handleFlightPathClick} disabled = {permissionCheck()} disableRipple>
          Flight Schedule
        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem className="no-hover" onClick={handleACHistoryClick} disableRipple>
          Aircraft History
        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem disabled={enableAttachmentButton()} className="no-hover"
          onClick={attachmentHandler} disableRipple>
          Attachments
        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem className="no-hover" disabled={specialEventChecker(DropdownConstant.FIELD_TRIP)} onClick={handleFieldTrip} disableRipple>
          Field trip
        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem className="no-hover" disabled={specialEventChecker(DropdownConstant.FERRY_FLIGHT)} onClick={handleSPF} disableRipple>
          SFP
        </MenuItem>
      </MoreButtons>

      <FlightPathModal
        isOpen={otsEvent.ShowFlightSchedule}
        close={handleFlightPathCloseModalClick}
        aircraftNumber={otsEvent.AircraftRegistration}
        confirm={() => {}}
      />
    </div>
  );
}

export default OtsMoreButtons;